import {https, httpsFile} from './http.js';
export function show(header,page,currentpage){
    return httpsFile().get(`po-details/${header}?page=${page}&currentpage=${currentpage}`);
}